import type { UserPuzzleStatsData } from 'client/types/UserPuzzleStatsData'
import { klubbleAPI } from './common'

export const fetchUserPuzzleStatsData = async (abortController?: AbortController) => {
  try {
    const res = await klubbleAPI.get<UserPuzzleStatsData>('Auth/getuserpuzzlestats', {
      signal: abortController?.signal,
    })
    if (res?.status === 200) {
      return res.data
    }
    throw new Error(`${res.config.url} returned status ${res.status}`)
  } catch (e) {
    throw new Error(`Error fetching user puzzle stats data: ${e.message}`)
  }
}
